// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart-container[data-v-0387d668] {\n  height: 600px\n}\n", ""]);
// Exports
module.exports = exports;
